import { render, staticRenderFns } from "./AinIndex.vue?vue&type=template&id=cedd1888&scoped=true"
import script from "./AinIndex.vue?vue&type=script&lang=js"
export * from "./AinIndex.vue?vue&type=script&lang=js"
import style0 from "./AinIndex.vue?vue&type=style&index=0&id=cedd1888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedd1888",
  null
  
)

export default component.exports